import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from "../src/components/Home.js";
import Navbar from "../src/components/Navbar.js";
import Holders from "../src/components/Holders.js";
import Leaderboards from "../src/components/Leaderboards.js";
import './App.css';

function App() {
  return (
    <Router>
      <div className="app-shell">
        <Navbar />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/holders" element = {<Holders />} />
            <Route path="/leaderboards" element = {<Leaderboards />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
